<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
  <path d="M7.75 0.75V14.75" stroke="black" stroke-width="1.5" stroke-linecap="round"/>
  <path d="M0.75 7.75L14.75 7.75" stroke="black" stroke-width="1.5" stroke-linecap="round"/>
</svg>
</template>

<style lang="scss" scoped>
</style>

<script>
export default {
  name: 'IconPlusSmall'
}
</script>
